export const FULFILLMENT_STATUS = {
  notBagged: 'Unbagged',
  bagged: 'Bagged',
  cancelled: 'Cancelled',
  changed: 'Changed',
  partial: 'Partial'
}

export const LANG = {
  REFRESH: 'Refresh',
  UNEXPECTED_ERROR: 'An unexpected error occurred. The page will now refresh.',
  ITEM_NOT_RECOGNIZED: 'Scanned item is not recognized.',
  ITEM_SCANNED_TOO_MANY: 'Item scanned too many times.',
  SCAN_FAILED_TO_SAVE: 'Warning: Scan failed to save to server',
  TABLE_DATA_FETCH_FAILED: 'Unable to fetch order data.',
  ERROR_SEARCHING_PACKAGES: 'Error searching for packages.',
  ERROR_SWAPPING_ITEMS: 'Error swapping items.',
  ERROR_COMPLETING_ORDER: 'Error completing order.',
  ERROR_CANCELLING_ORDER: 'Error cancelling order.',
  NO_MATCHING_PACKAGE: 'No matching package found.',
  ERROR_SAME_SUBLOT: 'Cannot swap to the same sub-lot.',
  ERROR_TOO_MANY_ITEMS_REMOVED: 'Too many items removed.',
  ERROR_TAKING_OVER_LOCK: 'Error taking over lock.',
  ERROR_FAILED_TO_ACQUIRE_LOCK: 'Failed to acquire lock.',
  ERROR_ORDER_CANT_BE_COMPLETED: "The order can't be completed until all items are scanned.",
  ERROR_ORDER_CANCELLATION_CANT_BE_FINALIZED: "Cancellation can't be finalized until all items are scanned.",
  ERROR_ORDER_CANT_BE_VERIFIED: "The order can't be verified until all items are scanned.",
  ERROR_UNRECOGNIZED_ORDER: 'Unrecognized order.',
  ERROR_FAILED_TO_CANCEL_ORDERS: 'Failed to cancel orders.',
  ERROR_FAILED_TO_NOTIFY_ORDERS: 'Failed to notify orders.',
  ERROR_NO_ORDERS_SELECTED: 'No orders selected.',
  ERROR_FINALIZING_CANCELLATION: 'Error finalizing order cancellation.',
  ERROR_VERIFYING_ORDER: 'Error verifying order.',
  ERROR_QUANTITY_EXCEEDS_ORIGINAL: 'Quantity exceeds original quantity.'
}

export const SYNC_ORDERS_TABLE_MS = 30000
export const SYNC_ORDERS_TABLE_MS_FAST = 10000

export const PERSIST_LOCK_MS = 20000

export const CONTEXT = {
  PACKING: 'PACKING',
  SWAPPING: 'SWAPPING',
  LOCKED: 'LOCKED'
}

export const FULFILLMENT_SERVICE = Symbol('fulfillment.service')
